import { render, staticRenderFns } from "./NotificationDropDown.vue?vue&type=template&id=7e745064&scoped=true"
import script from "./NotificationDropDown.vue?vue&type=script&lang=js"
export * from "./NotificationDropDown.vue?vue&type=script&lang=js"
import style0 from "./NotificationDropDown.vue?vue&type=style&index=0&id=7e745064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e745064",
  null
  
)

export default component.exports